import { Component, inject, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '../../../services/auth';
import { Location } from '@angular/common';
import { Help } from '../help/help';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { NavStateService } from '../../../services/nav-state.service';
import { Master } from '../../../services/master';
import { QuestionState } from '../../../services/question-state';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.html',
  styleUrl: './header.less'
})
export class Header implements OnInit {
  private authService = inject(Auth);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private location = inject(Location);
  public navState = inject(NavStateService);
  imgData: any;
  user: any;
  private masterService = inject(Master);
  private questionState = inject(QuestionState);
  inputField: any;
  @Output() toggleHistoryEvent = new EventEmitter<void>();
  chatHistory: { question: any, answer: any }[] = [];
  historyList: { question: any, answer: any }[] = [];
  tradeHistory: any[] = [];
  searchControl = new FormControl('');
  dropdownVisible: boolean = false;
  showHistory: boolean = false;
  rowNum: any = 0;
  size: any = 10;
  constructor() {
    this.authService.user.subscribe((x: any) => this.user = x);
    console.log(this.user);
    if (this.user != null && (this.user?.photoPath || this.user.photoPath != undefined)) {
      this.authService.imgData$.subscribe((img: any) => this.imgData = img);
    }

  }

  ngOnInit(): void {
    if (this.user != null && (this.user?.photoPath || this.user.photoPath != undefined)) {
      this.authService.imgData$.subscribe((img: any) => this.imgData = img);
    }
  }

  toggleHistory() {
    this.toggleHistoryEvent.emit();
  }

  getTradeGPTHistory(rowNum: any, size: any) {
    this.masterService.getTradeGPTHistory(rowNum, size).
      subscribe({
        next: (data: any) => {
          this.tradeHistory = data.rows;
          this.generateHistoryRecord(this.tradeHistory);
        }
      })
  }

  generateHistoryRecord(tradeHistory: any) {
    this.historyList = []; // Populate separate history list for sidebar
    for (let i = 0; i < tradeHistory.length; i += 2) {
      this.historyList.push({
        answer: tradeHistory[i].chat || null,
        question: tradeHistory[i + 1].chat || null
      })
    }
    this.questionState.setChatHistory(this.historyList);
  }

  logout() {
    this.imgData = null;
    this.authService.logout();
    //this.router.navigate(["/login"]);

  }

  toggleDropdown() {
    console.log('hello');
    console.log(this.dropdownVisible);
    this.dropdownVisible = !this.dropdownVisible;
  }

  openTradeGPTPage() {
    this.router.navigate(['/trade-gpt'], {
      state: { focusField: 'targetInput' }
    })
  }

  viewHelp() {
    const helpDialog = this.dialog.open(Help, {
      disableClose: true,
      height: '500px',
      width: '500px',
      panelClass: 'custom-dialog-container',
      hasBackdrop: true,
      autoFocus: false

    });

    helpDialog.afterClosed().subscribe({

    })
  }

  landingPage() {
    if (this.router.url === '/landing-page') {
      window.location.reload();
    } else {
      this.router.navigate(['/landing-page']);
    }
  }

  goBack() {
    this.location.back();
  }

  reloadPage() {
    window.location.reload();
  }

  login() {
    this.router.navigate(['/login']);
  }

  register() {
    this.router.navigate(['/registration']);
  }

  openProfilePage() {
    this.router.navigate(['/profile'])
  }

  navigateToTradeGPT() {
    this.router.navigate(['/trade-gpt'], {
      state: { focusField: 'targetInput' }
    })
  }
}
